module.exports = __webpack_public_path__ + "assets/img/icon_next_new.80cf1aff.svg";